import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';

// OnPush here was historically unsafe: it blocked zone-tick change detection from reaching
// Default-CD routed descendants (confirmed drawer regression). Since FRONT-383 every component
// in the app is OnPush and signal/markForCheck-driven, and RouterOutlet marks its host for
// check on activation, so that failure mode no longer exists. Validate map + drawer flows
// when touching this.
@Component({
  selector: 'main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SidebarComponent, RouterOutlet],
})
export class MainLayoutComponent {}
